// firebaseConfig.js
import { initializeApp } from "firebase/app"
import {
    getAuth,
    GoogleAuthProvider,
    signInWithPopup,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    sendEmailVerification,
    signOut,
    onAuthStateChanged,
} from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"
import { getRemoteConfig, fetchAndActivate, getValue } from "firebase/remote-config"

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
export const googleProvider = new GoogleAuthProvider()

// Remote Config — mirrors Resolut-App defaults so web + mobile share one source
// of truth for daily auto-apply limits.
export const remoteConfig = getRemoteConfig(app)
remoteConfig.defaultConfig = {
    swipe_count_a_day: 10,
    min_app_version: "1.0.0",
}
remoteConfig.settings.minimumFetchIntervalMillis = 60 * 60 * 1000 // 1h
remoteConfig.settings.fetchTimeoutMillis = 10 * 1000
let rcReadyPromise = null
export function ensureRemoteConfig() {
    if (!rcReadyPromise) rcReadyPromise = fetchAndActivate(remoteConfig).catch(() => {})
    return rcReadyPromise
}
export function rcSwipeCountADay() {
    try { return getValue(remoteConfig, "swipe_count_a_day").asNumber() || 10 }
    catch { return 10 }
}

export {
    signInWithPopup,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    sendEmailVerification,
    signOut,
    onAuthStateChanged,
}